import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { invoiceService} from "@/services/api/cresivoxServer";


import {iInvoiceWithItems, REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

  export const getInvoiceList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("invoiceList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
	  try {
		  const response = await invoiceService.getAllInvoice();
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						  return {
							  httpStatusCode,
							  data: data.data,
							  message,
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);

export const getInvoiceById = createAsyncThunk<
iGenericResponse<any | null> | null,
{invoiceId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getInvoiceById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await invoiceService.getInvoiceById(arg);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								invoice: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateInvoice = createAsyncThunk<
iGenericResponse<any | null> | null,
{invoiceId:string, data: iInvoiceWithItems},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateInvoice"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({invoiceId,data}, {rejectWithValue}) => {
	try {
		const response = await invoiceService.updateInvoice(invoiceId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const deleteInvoice = createAsyncThunk<
iGenericResponse<any | null> | null,
{invoiceId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteInvoice"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({invoiceId}, {rejectWithValue}) => {
	try {
		const response = await invoiceService.deleteInvoice(invoiceId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const createInvoice = createAsyncThunk<
iGenericResponse<any | null> | null,
iInvoiceWithItems,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("createInvoice"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await invoiceService.createInvoice(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


